import React, { useState, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import mtn from "../assets/mtn1.jpg";
import glo from "../assets/glo.jpg";
import airtel from "../assets/airtel.jpg";
import etisalat from "../assets/9mobile.jpg";

const AirtimeToCash = () => {
  const {
    sendAirtimeOtp,
    verifyAirtimeOtp,
    sendAirtimeToCash
  } = useContext(AuthContext);

  const navigate = useNavigate();

  // Form inputs
  const [network, setNetwork] = useState('');
  const [senderNumber, setSenderNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [amount, setAmount] = useState('');
  const [quantity, setQuantity] = useState(1);
  const [pin, setPin] = useState('');

  // Process states
  const [identifier, setIdentifier] = useState('');
  const [sessionId, setSessionId] = useState('');
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const handleSendOtp = async () => {
    setLoading(true);
    setError('');
    setSuccessMsg('');

    const result = await sendAirtimeOtp({ network, senderNumber });
    setLoading(false);
    console.log(result)

    if (result?.error) return setError(result.error);
    setIdentifier(result.identifier);
    setStep(2);
    setSuccessMsg('OTP sent successfully. Please enter it below.');
  };

  const handleVerifyOtp = async () => {
    setLoading(true);
    setError('');
    setSuccessMsg('');

    const result = await verifyAirtimeOtp({ identifier, otp });
    setLoading(false);

    if (result?.error) return setError(result.error);
    setSessionId(result.sessionId);
    setStep(3);
    setSuccessMsg('OTP verified. You can now send your airtime.');
  };

  const handleSendAirtime = async () => {
    setLoading(true);
    setError('');
    setSuccessMsg('');

    const reference = `A2C-${Date.now()}-${Math.floor(Math.random() * 10000)}`;

    const result = await sendAirtimeToCash({
      network,
      amount,
      quantity,
      pin,
      sessionId,
      reference
    });

    setLoading(false);

    if (result?.error) return setError(result.error);

    setSuccessMsg(result.data.message || 'Airtime sent successfully!');
    setTimeout(() => navigate('/transactions'), 2000); // redirect after success
  };

  return (
    <div className="">
      {error && <div className="error-text">{error}</div>}
      {successMsg && <div className="text-green-600 mb-3">{successMsg}</div>}

      {step === 1 && (
        <>
          <div className="network-selection">
            <label className="network-label">Select Network Provider</label>
            <div className="network-options">
              {[
                { id: "1", classKey: "mtn", src: mtn, alt: "MTN" },
                { id: "3", classKey: "glo", src: glo, alt: "Glo" },
                { id: "2", classKey: "airtel", src: airtel, alt: "Airtel" },
                { id: "4", classKey: "etisalat", src: etisalat, alt: "9mobile" }
              ].map(({ id, classKey, src, alt }) => (
                <img
                  key={id}
                  src={src}
                  alt={alt}
                  onClick={() => setNetwork(id)}
                  className={`network-image ${classKey === "mtn" ? "mtn-image" : ""} ${classKey === "glo" ? "glo-image" : ""
                    } ${network === id ? "selected" : ""}`}
                />

              ))}
            </div>
          </div>
          <label className="block mb-1">Sender Phone Number</label>
          <input
            type="text"
            value={senderNumber}
            onChange={(e) => setSenderNumber(e.target.value)}
            className="border p-2 w-full mb-3"
            placeholder="081XXXXXXXX"
          />

          <button onClick={handleSendOtp} disabled={loading} className="btn">
            {loading ? 'Sending OTP...' : 'Send OTP'}
          </button>
        </>
      )}

      {step === 2 && (
        <>
          <label className="block mb-1">Enter OTP</label>
          <input
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            className="border p-2 w-full mb-3"
            placeholder="Enter OTP"
          />

          <button onClick={handleVerifyOtp} disabled={loading} className="btn">
            {loading ? 'Verifying...' : 'Verify OTP'}
          </button>
        </>
      )}

      {step === 3 && (
        <>
          <label className="block mb-1">Airtime Amount</label>
          <input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            className="border p-2 w-full mb-3"
            placeholder="e.g. 50"
          />

          <label className="block mb-1">Quantity</label>
          <input
            type="number"
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            className="border p-2 w-full mb-3"
            placeholder="e.g. 5"
          />

          <label className="block mb-1">Transaction PIN</label>
          <input
            type="password"
            value={pin}
            onChange={(e) => setPin(e.target.value)}
            className="border p-2 w-full mb-3"
            placeholder="4-digit PIN"
          />

          <button onClick={handleSendAirtime} disabled={loading} className="btn">
            {loading ? 'Sending Airtime...' : 'Send Airtime'}
          </button>
        </>
      )}
    </div>
  );
};

export default AirtimeToCash;
